import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL || "";

const feedbacksApi = {
  getAllFeedbacks: async (page = 1, limit = 20) => {
    const response = await axios.get(`${API_URL}/api/admin/feedbacks?page=${page}&limit=${limit}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` },
    });
    return response.data;
  }
};
export default feedbacksApi;
